// http://shop.herbertz.de/shop/rest/data/search/typeahead?value=111&count=5&art_nr=true
import app from "app.controller"

export default class Typeahead {
  constructor({shop, config}) {
    this.config = config
    this.shop   = shop
    console.log(`config`, config)
  }

  load(value) {
    if (!value || value.length < 3) {return Promise.resolve([])}
    return this.shop.fetchCached(`data/search/typeahead?value=${value}&count=5&artnr=1&lang=${app._currentLanguage}`)
      .then(res => res.map(hit => hit.id))
  }

  loadWithProducts(value) {
    return this.load(value)
      .then(ids => {
        return this.shop.products.list(ids)
      })
      .then( res => {
     
        return res
      })
  }


}



// WEBPACK FOOTER //
// ./src/sdk/Typeahead.js